<div class="mt-4">
  <app-stepper
    [step]="2"
  ></app-stepper>
  <h2 class="mt-6 text-center text-xl-start  fw-bold" *ngIf="!loading && !loadingRedirect">
    {{ 'StepAct.Title' | translate }} {{ project.name }} 1
  </h2>
  <div class="lead text-center text-xl-start" *ngIf="!loading && !loadingRedirect">
    {{ 'StepAct.SubTitle' | translate }}
  </div>

  <ng-container *ngIf="!loading && !loadingRedirect">
    <!-- Error message for completed step -->
    <div class="alert alert-warning mt-3" *ngIf="showErrorMessageProjectNotActive">
      <p>{{ 'FailureMessages.' + errorCode | translate }}</p>
    </div>

    <!-- Error message for step already completed -->
    <div class="alert alert-info mt-3" *ngIf="showErrorMessageStepCompleted">
      <p>{{ stepCompletedErrorMessage }}</p>
    </div>

    <!-- Download Section -->
    <div class="download-section rounded-4 bg-primary p-3 p-lg-4 mt-4 mb-1" *ngIf="showDownloadbleFiles">
      <h3 class="pt-0 mt-0 text-white">{{ 'StepValueInDispute.TemplatesForDownload' | translate }}</h3>
      <div class="d-flex flex-column fs-6 mt-4" *ngFor="let download of downloadFiles">
        <a class="download-item text-decoration-none text-white mb-1" href="{{download.url}}" target="_blank">
          <i class="fa-solid fa-cloud-arrow-down pe-2"></i>
          {{ download.title }}
        </a>
      </div>
    </div>
    <div class="clear"></div>
    <form [formGroup]="dynamicForm" *ngIf="!showErrorMessageProjectNotActive && !showErrorMessageStepCompleted">
      <div *ngFor="let FormField of actFields">
        <ng-container *ngIf="FormField.type === 'boolean'">
          <app-form-input-dropdown
            [label]="FormField.spaLabel"
            [values]="FormField.options"
            [formName]="dynamicForm"
            [control]="getFormControl(FormField.fieldName)"
            [name]="FormField.fieldName"
            [dynamicFormSettings]="true"
            [placeholder]="'General.InputSelectPlaceholder' | translate"
          ></app-form-input-dropdown>
        </ng-container>
        <ng-container *ngIf="FormField.type === 'text'">
          <app-form-input-text
            [type]="'text'"
            [placeholder]="FormField.spaLabel"
            [required]="FormField.required ?? false"
            [name]="FormField.fieldName"
            [label]="FormField.spaLabel"
            [formName]="dynamicForm"
            [control]="getFormControl(FormField.fieldName)"
            [maxLength]="FormField.maxLength ?? undefined"
          ></app-form-input-text>
        </ng-container>
      </div>
    </form>
    <!-- Upload Section -->
    <ng-container *ngIf="uploadOfFilesRequired">
      <ng-container *ngFor="let actFileUpload of actRequiredFileCategories">
        <h4 class="mt-4 mt-xxl-5">{{ actFileUpload.title }}</h4>
        <app-form-input-file
          [formName]="dynamicForm"
          [name]="actFileUpload.fieldName"
          [minimumFiles]="actFileUpload.minimumFiles"
          [control]="getFormControl(actFileUpload.fieldName)"
          [projectShortName]="projectShortName"
          [tokenIdentifier]="tokenIdentifier"
          [sessionId]="sessionToken"
          [isClaimFile]="false"
          [fileCategory]="actFileUpload.id"
          [projectSettings]="projectSettings"
          [uploadedFiles]="filesByCategory[actFileUpload.fieldName] || []"
          (fileDeleted)="refreshFiles()"
          (fileUploaded)="refreshFiles()"
        >
        </app-form-input-file>
      </ng-container>
    </ng-container>
  </ng-container>
  <div class="mt-6 mt-xxl-4 text-end" *ngIf="!showErrorMessageProjectNotActive && !showErrorMessageStepCompleted">
    <app-form-button-submit *ngIf="!loading && !loadingRedirect"
                            [label]="'General.ButtonContinue' | translate"
                            [icon]="'angle-right'"
                            [active]="isFormValid()"
                            (click)="clickOnNextButton()"
    ></app-form-button-submit>
  </div>
</div>

<!-- Act Fields -->
<!--<ng-container *ngIf="actFields">-->
<!--  <form [formGroup]="dynamicForm">-->
<!--    <div *ngFor="let actField of actFields">-->
<!--      <app-form-switch-->
<!--        [formGroup]="dynamicForm"-->
<!--        [inputSetting]="actField"-->
<!--      ></app-form-switch>-->
<!--      {{actField.Type}}-->
<!--      {{actField.SpaLabel}}-->
<!--      {{actField.FieldName}}-->
<!--    </div>-->
<!--  </form>-->
<!--</ng-container>-->
